import { useCallback, useEffect, useRef, useState } from 'react'
import IconButton from "@/components/Primitive/Buttons/IconButton/IconButton"
import { ShowProps } from '@/components/Modal/UserNotify/IUserNotify'
import globalEvents from '@/services/GlobalEvents/GlobalEvents'
import { Events } from '@/services/GlobalEvents/constants'
import WarningImage from "./icons/warning.svg?react"
import CloseImage from '@/images/icons/close.svg?react'
import styles from './UserNotify.module.scss'

const CloseComponent = <CloseImage />

interface UserNotifyProps {
  timeout?: number
}

const DEFAULT_TIMEOUT = 3000

const UserNotify = ({timeout = DEFAULT_TIMEOUT}: UserNotifyProps = {}) => {
  const [message, setMessage] = useState('')
  const [show, setShow] = useState(false)
  const timer = useRef<NodeJS.Timeout>(undefined)

  useEffect(() => {
    const lTimer = timer
    return () => {
      clearTimeout(lTimer.current)
    }
  }, [])

  const showNotice = useCallback(({message, timeout: time}: ShowProps) => {
    clearTimeout(timer.current)
    setMessage(message)
    setShow(true)
    setTimeout(() => {
      setShow(false)
    }, time || timeout)
  }, [timeout])

  useEffect(() => {
    globalEvents.addEventListener(Events.showUserNotice, showNotice)
    return () => {
      globalEvents.removeEventListener(Events.showUserNotice, showNotice)
    }
  }, [showNotice])

  if (!show) {
    return null
  }

  return <div className={styles.notifyBox}>
    <WarningImage className={styles.icon} />
    <span className={styles.text}>{message}</span>
    <IconButton
      className={styles.btn}
      onClick={() => setShow(false)}
    >{CloseComponent}</IconButton>
  </div>
}

export default UserNotify
